/**
 * Constantes para el módulo de Inventario - Actualizado 2024
 */
import ScienceIcon from "@mui/icons-material/Science";
import HandymanIcon from "@mui/icons-material/Handyman";
import BugReportIcon from "@mui/icons-material/BugReport";
import SecurityIcon from "@mui/icons-material/Security";
import DescriptionIcon from "@mui/icons-material/Description";

export const TYPE_ICONS = {
  chemical: <ScienceIcon fontSize="small" />,
  tool: <HandymanIcon fontSize="small" />,
  trap: <BugReportIcon fontSize="small" />,
  epp: <SecurityIcon fontSize="small" />,
  service_format: <DescriptionIcon fontSize="small" />,
};

export const PRODUCT_FIELDS = [
  { name: "name", label: "Nombre del artículo", required: true },
  { name: "sku", label: "SKU / Código interno", required: true },
  {
    name: "type",
    label: "Tipo",
    type: "select",
    required: true,
    options: [
      { value: "chemical", label: "Químico" },
      { value: "tool", label: "Herramienta" },
      { value: "trap", label: "Dispositivo de Control" },
      { value: "epp", label: "Equipo de protección" },
      { value: "service_format", label: "Formato de servicio" },
    ],
  },
  { 
    name: "category", 
    label: "Categoría", 
    required: true,
    type: "autocomplete"
  },
  { name: "brand", label: "Marca" },
  {
    name: "description",
    label: "Descripción",
    multiline: true,
    rows: 3,
  },
  { 
    name: "warehouseStock", 
    label: "Stock en almacén", 
    type: "number",
    required: true
  },
  { 
    name: "minStock", 
    label: "Stock mínimo", 
    type: "number",
    defaultValue: 0
  },
  {
    name: "unit",
    label: "Unidad de medida",
    type: "select",
    required: true,
    defaultValue: "pieza",
    options: [
      { value: "lt", label: "Litros (lt)" },
      { value: "ml", label: "Mililitros (ml)" },
      { value: "kg", label: "Kilogramos (kg)" },
      { value: "g", label: "Gramos (g)" },
      { value: "pieza", label: "Piezas" },
      { value: "caja", label: "Cajas" },
      { value: "paquete", label: "Paquetes" },
    ],
  },
  {
    name: "cofeprisCat",
    label: "Categoría COFEPRIS",
    type: "select",
    defaultValue: "NA",
    options: [
      { value: "urbano", label: "Urbano" },
      { value: "jardineria", label: "Jardinería" },
      { value: "agricola", label: "Agrícola" },
      { value: "industrial", label: "Industrial" },
      { value: "NA", label: "No aplica" },
    ],
  },
  {
    name: "status",
    label: "Estado",
    type: "select",
    required: true,
    defaultValue: "active",
    options: [
      { value: "active", label: "Activo" },
      { value: "inactive", label: "Inactivo" },
    ],
  },
];

// Tipos de ubicación del inventario
export const LOCATION_TYPES = {
  WAREHOUSE: "warehouse",
  TECHNICIAN: "technician",
  HAZARDOUS: "hazardous",
};

// Configuración de tabs
export const TAB_CONFIG = [
  {
    id: 0,
    label: "Almacén Principal",
    location: LOCATION_TYPES.WAREHOUSE,
    description: "Stock central y punto de entrada",
  },
  {
    id: 1,
    label: "Técnicos",
    location: LOCATION_TYPES.TECHNICIAN,
    description: "Stock asignado a técnicos",
  },
  {
    id: 2,
    label: "Residuos Peligrosos",
    location: LOCATION_TYPES.HAZARDOUS,
    description: "Control de residuos y desechos",
  },
];
